<template>
  <div class="app sidebar-fixed aside-menu-fixed aside-menu-hidden agent-portal-admin" style="background-color: #F7F7F7">
    <skip-to-content></skip-to-content>
    <div style="background-color: #F7F7F7">
      <navigationtop></navigationtop>
      <div class="app-body">
        <navigation></navigation>
        <div id="main-content" class="main bg-white" role="main">
          <b-container fluid>
            <breadcrumbs></breadcrumbs>
            <section-alerts></section-alerts>
            <div v-if="$route.name === 'admin/dashboard'">
              <dashboard></dashboard>
            </div>
            <router-view v-else></router-view>
            <div v-if="showModal" id="reportsDownloadModal">
              <reports-download @displayModal="showModal = !showModal"></reports-download>
            </div>
          </b-container>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import User from '@/services/User';
import Breadcrumbs from '../presentational/widgets/Breadcrumbs';
import Navigation from '../presentational/widgets/Navigation';
import Navigationtop from '../presentational/widgets/Navigationtop';
import SectionAlerts from '../presentational/alerts/SectionAlerts';
import ReportsDownload from './ReportsDownload';
import Dashboard from './dashboard/Dashboard';
import SkipToContent from '../shared/SkipToContent';

export default {
  data() {
    return {
      showModal: false,
    };
  },
  components: {
    Breadcrumbs,
    Navigation,
    Navigationtop,
    SectionAlerts,
    ReportsDownload,
    Dashboard,
    SkipToContent,
  },
  methods: {
    dailyActivityReportInit() {
      // TODO: Use config values
      const dailyActivityReportEl = document.querySelector('.daily-activity-report');

      if (dailyActivityReportEl) {
        dailyActivityReportEl.addEventListener('click', (e) => {
          e.preventDefault();
          window.console.info('Displaying Daily Activity Report Download');

          this.showModal = true;
          setTimeout(() => {
            const pageFirstElement = document.getElementById('report-modal-close');
            pageFirstElement.focus();
          }, 200);
        });
      }
    },
  },
  mounted() {
    User.init(); // Initialize the user

    this.dailyActivityReportInit();

    // TODO: Abstract to helper function
    const appContainer = document.getElementById('app-container');

    if (appContainer) {
      appContainer.classList.add('admin-nav');
      appContainer.classList.remove('stacked-nav');
    }
  },
  beforeDestroy() {
    const appContainer = document.getElementById('app-container');

    if (appContainer) {
      appContainer.classList.remove('admin-nav');
      appContainer.classList.remove('stacked-nav');
    }
  },
};
</script>
<style>
.main {
  margin-left: 200px; /* TODO: Use Bootstrap JS */
}
  /* Collapsed Sidebar */
  .main.collapsed-sidebar {
    margin-left: 50px; /* TODO: Use Bootstrap JS */
  }

.app .app-body {
    margin-top: 3rem;
    height: calc(100vh - 3rem);
}

h1, .h1 {
  font-size: 1.0rem;
  font-weight: 700;
}

.display-1 {
    color: #003366;
    font-size: 1.5rem;
    font-weight: normal;
    text-transform: capitalize;
    min-height: 2.25rem;
}

.btn, select{
  cursor: pointer;
}

.custom-select:disabled{
  cursor: default;
  border: 1px solid #ccc !important;
  background-color: #ededed !important;
  color: #646464 !important;
}

/**Report Download Modal CSS**/
#reportsDownloadModal{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 1060;
}

#reportsDownloadModal .card {
  top: 50%;
}
  #reportsDownloadModal .card-header{
    background: #3674B2;
  }
  #reportsDownloadModal .card-body button i.fa-circle-o-notch:before{
    content: "\f1ce";
    font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
  }

/**DataTable Header CSS**/
.table-head .form-group .input-group {
  min-width: 300px
}
/**Data Table CSS**/
.table th, .table td {
  border-top: 1px solid #cccccc;
}
table td {
  word-wrap: break-word;
}

table.table-hover tbody tr:nth-child(even) {
  background: #f4f4f4 !important;
}
  table.table-hover tbody tr:hover {
    background-color: rgba(0, 204, 0, 0.05) !important;
  }

.table.b-table {
  overflow-x: auto;
}
  /**Data Table - ADD H-Scroll CSS**/
  @media (max-width: 992px){
    #report .table.b-table {
      display: block;
    }
      #report .table.b-table th{
        min-width: 120px;
      }
  }
  .table.b-table thead, #manage-table thead {
   -webkit-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1) !important;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.1) !important;
  }

  .table.b-table th, #manage-table th{
    position: relative;
    padding-right: 20px;
    vertical-align: middle;
    color: #003366;
  }
    /**Data Table Header Sort Ascending/Decending Icons**/
  #report .table.b-table th[aria-sort], #manage-table th[aria-sort]{
    cursor: pointer;
  }

    /**Data Table Header Sort Ascending/Decending Icons**/
    #report .table.b-table th[aria-sort]::after,
    #manage-table th[aria-sort]::after {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 7px;
      font-family: "Font Awesome 5 Pro", "Font Awesome 5 Free";
      content: "\f30c" "\f309";
      color: #949494;
    }
      th[aria-sort="ascending"], th[aria-sort="descending"] {
        background-color: rgba(54, 116, 178, 0.1);
      }
      #report .table.b-table th[aria-sort="ascending"]::after,
      #manage-table th[aria-sort="ascending"]::after {
        content: "\f30c" !important;
        color: rgba(0, 51, 102, 1.0) !important;
      }
      #report .table.b-table th[aria-sort="descending"]::after,
      #manage-table th[aria-sort="descending"]::after {
        content: "\f309" !important;
        color: rgba(0, 51, 102, 1.0) !important;
      }

  .table.b-table th, #manage-table th, .table.b-table td{
    border-left: 1px solid #cccccc;
    border-right: 1px solid #cccccc;
  }
  .table-sm th, .table-sm td{
      padding: 0.5rem;
  }

#manage-table tr:last-child,
#report .table.b-table tr:last-child {
  border-bottom: 1px solid #cccccc !important;
}

/**REPORTS: DataTable CSS**/
#report .table.b-table td{
  text-align: right;
}
  #report .table.b-table td:first-child {
      text-align: left;
    }

/**Management DataTable CSS**/
  /**Switch Styling Override CSS**/
  .custom-control-input:checked ~ .custom-control-label::before{
    color: #fff;
    border-color: #ccc;
    background-color: #2E7B32;
  }
  .custom-disabled.custom-control-input:checked ~ .custom-disabled.custom-control-label::before{
    border: 1px solid #ccc !important;
    background-color: #d0d0d0 !important;
    color: #FFF !important;
  }
  .custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before{
    border: 1px solid #ccc !important;
    background-color: #d0d0d0 !important;
    color: #FFF !important;
  }
  .custom-control-input:disabled ~ .custom-control-label::before {
    border: 1px solid #ccc !important;
    background-color: #d0d0d0 !important;
    color: #FFF !important;
  }
  .read-only-states .custom-control-input:disabled:checked ~ .custom-control-label::before {
    border: 1px solid #ccc !important;
    background-color: #d0d0d0 !important;
    color: #FFF !important;
  }
  .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
    border-color: 1px solid #ccc !important;
    background-color: #d0d0d0 !important;
    color: #FFF !important;
  }
  .edit-agency {
    cursor: pointer;
  }
  #manage-table tbody td a.edit-agency{
    color: #003366;
    fill: currentColor;
  }
  #manage-table tbody td a.edit-agency:focus {
  }
  #dimension-filters{
    color: #ffffff !important;
  }
.breadcrumb-item.active {
  color: #545454 !important;
}
/**Breadcrumb CoreUI Override CSS**/
.breadcrumb{
  padding: 0.5rem 0.875rem;
  margin-bottom: 1.0rem;
}

/**WIDGET STYLING**/
.card.no-padding,
.card.no-padding .card-body {
  padding: 0 !important;
}
</style>
<style lang="scss">
label { // Used for all labels in all components within the Admin section
  margin-bottom: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;

  &.field-required::after {
    content: '*';
    color: #FF4400;
    font-weight: 700;
    padding-left: 2px;
  }
}
.admin-nav .btn-success {
  background-color: #2E7B32 !important;
  border-color: #2E7B32 !important;
}
.admin-nav .btn-success:hover {
  background-color: #ffffff !important;
  border-color: #2E7B32 !important;
  color: #2E7B32 !important;
}
.admin-nav .btn-success:focus, .admin-nav .btn-outline-secondary:focus, #report .btn-primary:focus, #reportsDownloadModal .btn-primary:focus{
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
#report .btn-primary, #reportsDownloadModal .btn-primary, .download-file-block .btn-primary{
  color: #fff !important;;
  background-color: #2E7B32 !important;
  border-color: #2E7B32;
}
#report .btn-primary:hover, #reportsDownloadModal .btn-primary:hover, .download-file-block .btn-primary:hover {
  color: #2E7B32 !important;;
  background-color: #ffffff !important;
  border-color: #2E7B32 !important;
}
.admin-nav .text-muted {
  color: #595959 !important;
}
.page-link {
  color: #003366 !important;
}
.page-item.active .page-link {
  background-color: #003366;
  border-color: #003366;
  color: #fff !important;
}
.page-link:hover {
  background-color: #677580 !important;
  border-color: #677580 !important;
  color: #ffffff !important;
}
.page-link:focus {
  box-shadow: 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
.page-item.disabled .page-link{
  color: #949494 !important;
  background-color: #ededed !important;
}
.edit-user:hover, .edit-agency:hover {
  color: #036 !important;
}
.btn-outline-secondary:hover, .btn-outline-secondary:active{
  color: #fff !important;
  border-color: #595959 !important;
  background-color: #595959 !important;
}
.form-control:disabled, .form-control[readonly] {
  border: 1px solid #ccc !important;
  background-color: #ededed !important;
  color: #646464 !important;
}
.v-select .form-control:disabled, .v-select .form-control[readonly] {
  border: none !important;
}
.card {
  border: 1px solid #CCCCCC !important;
}
.table thead th {
 border-bottom: 2px solid #cccccc !important;
}
.agent-portal-admin .bg-ltblue{
 background-color: #00162B !important;
}
.search-box-admin .input-group-text {
  background-color: #ffffff !important;
}
.search-box-admin .search-text-box-admin {
  border-left: none !important;
  border: none !important;
}
.search-box-admin .input-group:focus-within {
  box-shadow: 0 0 0.2rem rgba(255, 255, 255, 0.5) !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(255, 255, 255, 0.5) !important;
  border-radius: 0.25rem !important;
}
.search-box-admin .search-text-box-admin:focus{
  box-shadow: none !important;
}
.search-box-admin .input-group-text {
  padding-right: 2px !important;
  border: none !important;
  padding-left: 7px !important;
}
.breadcrumb-first-item:focus, #report-modal-close:focus {
  box-shadow: 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
.breadcrumb-first-item:focus-visible {
    outline: none !important;
}
.btn.btn-outline-success{
  color: #ffffff !important;
  background-color: #2E7B32;
  border-color: #2E7B32 !important;
}
.btn.btn-outline-success:hover{
  color:  #2E7B32 !important;
  background-color:#ffffff !important;
  border-color: #2E7B32 !important;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus{
 -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
.btn-outline-success:focus{
 -webkit-box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
  box-shadow: 0 0 0 0.2rem rgba(51, 51, 51, 0.45) !important;
}
</style>
<style scoped>
/**Fluid Container CoreUI Override CSS**/
.container-fluid {
    padding-right: 15px !important;
    padding-left: 15px !important;
}

</style>




// WEBPACK FOOTER //
// src/components/admin/Admin.vue?4845089e